export default {
    mysql : {
        title : '云数据库',
        common : {
          series : '系列',
          storage : '存储空间',
          zone : '可用区',
          typePrimary : '常规实例',
          typeReadonly : '只读实例',
        },
        list : {
          searchHolder : '搜索名称',
          columnName : '名称/ID',
          columnVersion : '数据库版本',
          columnRole : '实例类型',
          columnPeriod : '有效期',
          columnCharge : '费用（$/月）',
          columnStatus : '运行状态',
          actionManager : '管理实例',
          actionRenew : '实例续费',
          actionUpgrade : '升级配置',
          actionRestore : '数据库恢复',
          seriesHigh : '高可用版',
          seriesBasic : '基础版',
          noDataTips : '没有数据，您可以',
          noDataAction : '创建一个实例',
          purchaseBtnTips : '购买MySQL数据库',
        },
        manageMenu : {
          basic : '基本信息',
          account : '账号管理',
          db : '数据库管理',
          backup : '恢复备份',
          monitor : '监控与报警',
          log : '日志管理',
          param : '参数设置',
        },
        detail : {
          actionBackup : '备份实例',
          actionRestart : '重启实例',
          createdLabel : '创建于',
          basicInfo : {
            title : '基本信息',
            name : '名称',
            type : '类型',
            storageType : '存储类型',
          },
          connection : {
            title : '连接信息',
            innerAddress : '内网地址',
            innerPort : '内网端口',
            outerAddress : '外网地址',
            outerPort : '外网端口',
            actionApply : '开通外网地址',
            actionEdit : '编辑',
            actionReleasePublic : '释放外网地址',
            actionReleaseConnections : '外网最大连接数',
            releaseConnectionsTips : '释放数据库连接会话',
            publicBandWidth : '最大外网带宽',
            actionSpeed : '带宽临时提速',
            actionWhitelist : '编辑外网白名单',
          },
          status : {
            title : '运行状态',
            status : '运行状态',
            methodLabel : '付费方式',
            method : '包月',
            created : '创建时间',
            overdueTips : '已过期 ${yisuReplace} 天',
            willOverdueTips : '${yisuReplace} 天内过期',
          },
          configuration : {
            title : '配置信息',
            version : '数据库版本',
            cpu : 'CPU',
            memory : '内存',
            iops : '最大IOPS',
            connections : '最大连接数',
            maintainPeriod : '可维护时间段',
            actionEdit : '编辑',
          },
          usage : {
            title : '使用量统计',
            used : '已使用',
            total : '总共',
            backup : '备份使用量',
            data : '数据',
            log : '日志',
          },
        },
        accounts : {
          actionCreate : '创建账号',
          actionDelete : '删除',
          actionRemark : '编辑描述',
          actionEdit : '设置权限',
          actionResetHigh : '重置权限',
          actionPassword : '重置密码',
          columnAccount : '账号',
          columnType : '账号类型',
          columnOuter : '外网连接账号',
          columnDbs : '所属数据库',
          columnDesc : '备注',
          columnStatus : '状态',
          statusActive : '可用',
          statusExpired : '不可用',
        },
        database : {
          actionCreate : '创建数据库',
          actionRemark : '修改备注',
          actionDelete : '删除数据库',
          columnDbName : '数据库名称',
          columnAccounts : '用户账号',
          columnCharacter : '字符集',
          columnStatus : '数据库运行状态',
          columnDesc : '备注',
          statusExpired : '未激活',
          statusActive : '运行中',
        },
        backup : {
          data : {
            title : '数据备份',
            columnPeriod : '备份开始/结束时间',
            columnName : '文件名',
            columnSize : '备份大小',
            columnTime : '备份集恢复时间点',
            columnMethod : '备份方法',
            columnType : '备份类型',
            columnStatus : '状态',
            statusExpired : 'Expired',
            statusSuccess : '成功',
            actionConvert : '转换为SQL文件',
          },
          log : {
            title : '日志备份',
            columnStart : '文件记录的开始时间',
            columnEnd : '文件记录的结束时间',
            columnSize : '文件大小',
          },
          setting : {
            title : '备份设置',
            retentionLabel : '数据备份保留（天数）',
            cycleLabel : '备份周期',
            nextLabel : '预计下次备份时间',
            action : '编辑',
          },
          actionDownload : '下载',
          actionRecover : '数据库 库/表级别恢复',
          startHolder : '开始时间',
          endHolder : '结束时间',
          keywordHolder : '输入文件名',
        },
        monitor : {
          engine : {
            title : '引擎监控',
            option1Title : 'TPS（平均每秒事务数）/ QPS（平均每秒SQL语句执行次数）',
            option1Legend : ["平均每秒事务数", "平均每秒SQL语句执行次数"],
            option2Title : 'InnoDB缓存读命中率，使用率，脏块率（%）',
            option2Legend : ["缓存池的读命中率", "缓存池命中率", "缓存池脏块百分率"],
            option3Title : 'InnoDB读写量(单位为KB)',
            option3Legend : [
              "InnoDB平均每秒读取数据量",
              "InnoDB平均每秒写入数据量",
            ],
            option4Title : 'InnoDB缓存请求次数',
            option4Legend : [
              "平均每秒从InnoDB缓存池的读次数",
              "平均每秒从InnoDB缓存池的写次数",
            ],
            option5Title : 'InnoDB日志读/写/fsync',
            option5Legend : [
              "平均每秒日志写请求书",
              "平均每秒向日志文件的物理写次数",
              "平均每秒向日志文件完成的fsync（）写数量",
            ],
            option6Title : 'MySQL执行语句时在硬盘上自动创建的临时表的数量',
            option6Legend : [],
            option7Title : 'MySQL_COMDML',
            option7Legend : [
              "平均每秒Delete语句执行次数",
              "平均每秒Insert语句执行次数",
              "平均每秒Insert Select语句执行次数",
              "平均每秒Replace语句执行次数",
              "平均每秒Replace Select语句执行次数",
              "平均每秒Select语句执行次数",
              "平均每秒update语句执行次数",
            ],
            option8Title : 'MySQL_RowDML',
            option8Legend : [
              "平均每秒从InnoDB表读取的行数",
              "平均每秒从InnoDB表更新的行数",
              "平均每秒从InnoDB表删除的行数",
              "平均每秒从InnoDB表插入的行数",
              "平均每秒向日志文件的物理写次数",
            ],
            option9Title : 'MyISAM读写次数',
            option9Legend : [
              "MyISAM平均每秒钟从缓存池种的读取次数",
              "MyISAM平均每秒钟从缓存池种的写入次数",
              "MyISAM平均每秒钟从硬盘上的读取次数",
              "MyISAM平均每秒钟从硬盘的写入次数",
            ],
            option10Title : 'MyISAM Key Buffer 读/写/利用率（%）',
            option10Legend : [
              "MyISAM平均每秒key buffer利用率",
              "MyISAM平均每秒key buffer读命中率",
              "MyISAM平均每秒key buffer写命中率",
            ],
          },
          resource : {
            title : '资源监控',
            option1Title : 'CPU和内存利用率(%)',
            option1Legend : ["CPU使用率", "内存使用率"],
            option2Title : '磁盘空间（MByte）',
            option2Legend : [
              "磁盘空间总体使用量",
              "数据空间使用量",
              "日志空间使用量",
              "临时文件空间使用量",
              "系统文件空间使用量",
            ],
            option3Title : 'IOPS(输入/输出操作 次/秒）',
            option3Legend : ["当前实例IOPS使用量"],
            option4Title : '总连接数',
            option4Legend : ["当前总连接数", "当前活跃连接数"],
            option5Title : '网络流量（KB）',
            option5Legend : [
              "平均每秒输入流量",
              "平均每秒输出流量",
            ],
          },
          error : '获取监控数据失败',
          actionSetting : '监控频率设置',
          startHolder : '开始时间',
          endHolder : '结束时间',
        },
        log : {
          detail : {
            title : '慢日志明细',
            columnTime : '执行开始时间',
            columnStatment : 'SQL语句',
            columnIp : '客户端IP',
            columnDb : '数据库名',
            columnExecute : '执行时长（秒）',
            columnLock : '锁定时长（秒）',
            columnParsed : '解析行数',
            columnReturned : '返回行数',
          },
          summary : { 
            title : '慢日志统计',
            columnTime : '时间',
            columnDb : '数据库名',
            columnStatment : 'SQL语句',
            columnExecutions : '执行详情',
            columnPendding : '等待解锁',
            columnExamined : '扫描行数',
            columnReturned : '返回行数',
            ExecutionTotal : '总执行数',
            ExecutionsTime : '总执行时间',
            ExecutionsTimeMax : '最大执行时间',
            totalLock : '总锁定时间',
            maxLock : '最大锁定时间',
            totalParse : '总解析行数',
            maxParse : '最大解析行数',
            totalReturn : '总返回行数',
            maxReturn : '最大返回行数',
          },
          actionSetting : '设置慢日志',
          searchHolder : '输入SQL语句查找',
        },
        param : {
          columnName : '参数名称',
          columnValue : '参数当前值',
          columnDesc : '描述',
          columnStart : '是否需要重启',
          actionEdit : '编辑',
        },
        modals : {
          common : {
            columnName : '实例名称',
            columnConfiguration : '配置',
            columnType : '数据库类型',
            columnZone : '地区/可用区',
            columnExpired : '到期时间',
          },
          rename : {
            title : '修改名称',
            warn : '您确定要对<span>${yisuReplace}</span>修改名称吗？',
            holder : '请输入新的名称',
            new : '新名称:',
            tips : '2-64个字符',
          },
          restart : {
            title : '重启实例',
            tips : '确定重启实例<span>${yisuReplace}</span> 吗？',
            action : '重启',
          },
          renew : {
            title : '实例续费',
            durationDays : '续费时长 (天): ',
            duration : '续费时长:'
          },
          upgrade : {
            title : '升级配置',
            tips : "RDS变更配置可能涉及底层数据迁移，请您耐心等待。在迁移完成后会进行切换，切换时会出现30秒左右的闪断，请确保应用具备重连机制。",
            delay : '可维护时间内进行切换（当前设置：${yisuReplace}) 修改',
            now : '数据迁移后立即切换',
            switch : '切换时间:',
            product : '规格 :',
          },
          releaseAddress : {
            title : '释放外网地址',
            warn : '确认释放外网地址？',
            tips : "释放外网地址将无法继续通过当前连接地址进行外网连接MySQL实例",
            actionRelease : '释放',
          },
          whitelist : {
            title : '编辑外网白名单',
            whitelistLabel : '白名单',
            ipEmpty : '白名单IP不能为空',
            ipLess : '有效IP数不能少于1个',
            ipLimit : '白名单IP数不能超过50个',
            ipInvalid : 'IP格式错误',
            tips : '用句号分隔多个IP地址。\nIP白名单设置为0.0.0.0/0代表允许所有地址访问外网地址，设置为127.0.0.1代表禁止所有地址访问。',
          },
          editAddress : {
            title : '编辑外网地址',
            nameLabel : '名称',
            warn1 : '以小写字母开头。',
            warn2 : '长度限制为22-50个字符。',
            warn3 : '支持字母、数字和连字符（-）。',
            warnNoChange : '连接字符串没有改变',
            warnLimit : '长度限制为22-50个字符',
          },
          setMaintain : {
            title : '修改可维护时间段',
            label : '设置可维护时间段',
            symbol : '至',
            holderStart : '开始时间',
            holderEnd : '结束时间',
          },
          connections : {
            title : '释放数据库连接会话',
            columnId : 'ID',
            columnVisitor : '访问IP',
            columnAccount : '账号',
            columnTime : '连接时长',
            warnNoSelect : '没有选中要释放的连接会话',
            warnNoConnections : '当前暂无连接会话',
            action : '释放',
            actionAll : '释放所有',
          },
          speed : {
            title : '带宽临时提速',
            warn : '确认将带宽提速到10M并保持24小时？',
            tips : '24小时后带宽将降回至5M。',
            action : '提速',
          },
          applyAddress : {
            title : '申请外网连接地址',
            tips1 : "由于通过外网地址操作云数据库MySQL会极大程度地降低了传输效率，\n因此请勿将外网地址在生产环境的应用中使用。",
            tips2 : "开通外网地址后，数据库账号列表将增加显示每个账号的外网连接账号，需使用外网连接账号才能外网访问数据库。",
            action : '确定',
          },
          addAccount : {
            title : '创建账号',
            nameLabel : '数据库账号',
            nameHolder : '请填写账号名称',
            nameRule : '账号名称必须由小写字母，数字、下划线组成、字母开头，字母或数字结尾，最长16个字符',
            privilegeLabel : '账号类型',
            typeHigh : '高权限账号',
            typeOrdinary : '普通账号',
            ordinaryTips : '（只能向已授权了的库导入数据）',
            actionSelectDb : '未授权的数据库',
            actionAuthorize : '授权',
            columnAuthorized : '已授权的数据库',
            columnPrivilege : '授予权限',
            radioWrite : '读写',
            radioRead : '只读',
            radioDDL : '仅DDL',
            radioDML : '仅DML',
            all : '全设为',
            passwordLabel : '新密码',
            passwordHolder : '请输入新密码',
            passwordRule : "大写、小写、数字、特殊字符占三种，长度为8－32位；特殊字符为!@#^&*()_+-=",
            confirmPassword : '确认密码',
            descLabel : '描述',
          },
          accountPassword : {
            title : '重置密码',
            tips : '重置账号${yisuReplace}的密码',
          },
          deleteAccount : {
            title : '删除账号',
            tips : '确认删除<span>${yisuReplace}</span>吗？',
            warn : '删除后不可恢复，请谨慎操作',
          },
          accountRemark : {
            title : '备注',
            remarkHolder : '请输入备注',
            tips : '修改账号<span>${yisuReplace}</span>的备注',
            warn : '请输入备注',
          },
          accountPrivilege : {
            title : '设置权限',
            tips : '修改账号${yisuReplace}的权限',
          },
          resetHigh : {
            title : '重置高权限账号',
            tips : '真的要重置高权限账号的权限吗？',
            warn : '重置后，您对高权限账号做的权限修改将会重置为系统默认分配的权限',
          },
          createDatabase : {
            title : '创建数据库',
            nameLabel : '数据库名称',
            nameHolder : '请输入数据库名称',
            tips : '由小写字母、数字、下划线组成，以字母开头，字母或数字结尾，最多64个字符',
            charsetLabel : '支持字符集',
            otherCharset : '其他',
            authAccountLabel : '授权账号',
            unauthAccountHolder : '未经授权的帐户（默认）',
            buttonCreateAccount : '创建新账号',
            privilegeLabel : '账号权限',
            descLabel : '备注',
            descHolder : '备注说明最多256个字符。',
            nameWarn : '数据库名称格式错误',
            accountWarn : '请选择账号权限',
            charactorWarn : '请选择字符集',
            descWarn : '备注说明最多256个字符。',
          },
          deleteDatabase : {
            title : '删除数据库',
          },
          databaseRemark : {
            title : '修改备注',
            tips : '修改数据库<span>${yisuReplace}</span>的备注',
            holder : '请在此输入备注内容',
            enterWarn : '请在此输入备注内容',
            noModifiedWarn : '没有任何改变',
            limitWarn : '备注说明最多256个字符。',
          },
          downloadBackup : {
            title : '实例备份文件下载',
            dataTips : '云服务器与云数据库地域相同时，在云服务器上使用内网下载地址，下载速度和安全性更高。',
            logTips : '云服务器与云数据库地域相同时，在云服务器上使用内网下载地址，下载速度和安全性更高。',
            warn : "如果您未安装Flash插件或版本过低，“复制下载地址”功能将无法使用。",
            dataCopy : '复制下载地址',
            logCopy : '复制链接',
            download : '下载',
          },
          convertBakcup : {
            title : '转换为SQL文件',
            tips : '确认将xb文件转化为SQL文件吗？',
            convert : '转换',
          },
          backupSetting : {
            title : '备份设置',
            retentionLabel : '数据备份保留',
            cycleTips : '单击下拉菜单以选择或取消选择',
            cycleLabel : '备份周期',
            timeLabel : '备份时间',
            monday : '星期一',
            tuesday : '星期二',
            wednesday : '星期三',
            thursday : '星期四',
            friday : '星期五',
            saturday : '星期六',
            sunday : '星期日',
            tips1 : "超出免费额度的备份使用量将会产生额外的费用，具体请参考 计费文档。",
            tips2 : "更新备份设置,需要重启MySQL服务.",
            tips3 : '更改备份设置大约需要30s~60s左右时间.',
          },
          backupRecover : {
            title : '数据库 库/表级别恢复',
            methodLabel : '还原方式',
            methodSets : '按备份集',
            methodTime : '按时间点',
            setsLabel : '备份集',
            timeLabel : '选择恢复时间点',
            unSelectedLabel : '需要恢复的库和表',
            columnDb : '库名',
            dbKeywordHolder : '通过数据库库名进行查询',
            columnTb : '表名',
            tbKeywordHolder : '通过表名进行查询',
            selectHolder : '选择',
            noDataTips : '无可用数据',
            selectedLabel : '已选择的表和库',
            columnNewDb : '新库名',
            columnNewTb : '新表名',
            actionDelete : '移除',
            sumLabel : '已选库表总大小',
            tips1 : "库表恢复中会进行一次HA切换，请恢复后确认连接情况",
            tips2 : "恢复结果请关注服务器状态和数据库表单更新结果",
          },
          backup : {
            title : '备份实例',
            mode : '备份方式',
            modePhysic : '物理备份',
            modeLogic : '逻辑备份',
            tips : '备份将在一分钟后开始',
            strategy : '备份策略',
            strategyDb : '数据库备份',
            strategyInstance : '实例备份',
            dbLabel : '库名',
            actoin : '备份',
          },
          monitorSetting : {
            title: '监控频率设置',
            label : '监控频率',
            unit : '秒/次',
            tips1 : '当前实例配置:${mysqlSeries}, ${mysqlMemory}GB',
            tips2 : "基础版及内存小于8G的数据库实例不支持5 秒/次的采集频率。",
          },
          setSlow : {
            title : '设置慢查询日志',
            tips : '启用慢查询可能会影响性能。',
            timeLabel : '慢查询时间（秒）',
            switchLabel : '慢查询开关',
          },
          paramSetting : {
            title : '修改配置',
            keyLabel : '键',
            valueLabel : '值',
          },
        }
      }
  }
  


// WEBPACK FOOTER //
// ./src/lang/zh-CN/mysql.js